import { css } from "@emotion/react";

export const styles = {
  base: css`
    display: flex;
    flex-direction: column;
    gap: var(--spacing-16);
  `,
  withLabel: css`
    margin-top: var(--spacing-8);
  `,
  error: css`
    border: 1px solid var(--color-danger);
    border-radius: var(--border-radii-base);
    padding: var(--spacing-8);
  `
};
